import axios from '@/libs/api.request'

export const saveErrorLogger = info => {
  return axios.request({
    url: '/api/sysOplog/saveErrorLogger',
    data: info,
    method: 'post'
  })
}
// 枚举列表
export const getEnumListByCls = (data) => {
  let kuData = JSON.parse(sessionStorage.getItem('enumerationData')) || {}
  if (kuData.hasOwnProperty(`${data.enumClassName}`)) {
    // console.log(data.enumClassName,'存过值了',kuData[`${data.enumClassName}`])
    return new Promise((resolve, reject) => {
      let list = kuData[`${data.enumClassName}`]
      resolve({ data: { code: 0, data: list, mag: 'ok' } })
    })
  } else {
    // console.log('请求了接口数据')
    return axios.request({
      data: data,
      url: `/api/api/getEnumListByCls`,
      method: 'post',
      headers: {
        noEncryption: true
      }
    })
  }
}
// 枚举列表
export const getDictListByDicType = (data = {}) => {
  let otherData = { flag: true }
  Object.assign(data, otherData)
  let kuData = JSON.parse(sessionStorage.getItem('dictypeData')) || {}

  if (kuData.hasOwnProperty(`${data.typeCode}`)) {
    // console.log(data.enumClassName,'存过值了',kuData[`${data.enumClassName}`])
    return new Promise((resolve, reject) => {
      let list = kuData[`${data.typeCode}`]
      resolve({ data: { code: 0, data: list, mag: 'ok' } })
    })
  } else {
    // console.log('请求了接口数据')
    return axios.request({
      data: data,
      url: `/api/api/getDictListByDicType`,
      method: 'post',
      headers: {
        noEncryption: true
      }
    })
  }
}

// 查询职位及人数
export const selectSingleRankAndCount = (data) => {
  return axios.request({
    data: data,
    url: `/api/hr/positionAndRank/selectSingleRankAndCount`,
    method: 'post'
  })
}
// 根据文档编号查询文件信息
export const queryDocFilesByDocumentNo = (data) => {
  return axios.request({
    data: data,
    url: `/api/doc/queryDocFilesByDocumentNo`,
    method: 'post'
  })
}
// 生成签名
export const getSignature = (data) => {
  return axios.request({
    data: data,
    url: `/api/api/doSignature`,
    method: 'post'
  })
}

// 报销科目下拉列表
export const selectPaidbackAccountListByForm = (data) => {
  return axios.request({
    data: data,
    url: `/api/admin/paidbackaccount/selectPaidbackAccountListByForm`,
    method: 'post'
  })
}
// 通过文档编号下载多个文件
export const downloadByDocumentNo = (data, params) => {
  return axios.request({
    data: data,
    url: `/api/api/downloadByDocumentNo`,
    method: 'post',
    ...params
  })
}

// 批量查询文档编号
export const queryDocFilesByDocumentNos = (data) => {
  return axios.request({
    url: '/api/doc/queryDocFilesByDocumentNos',
    method: 'post',
    data: data
  })
}

// 获取租户信息ById
export const queryCurrentTenant = (data) => {
  return axios.request({
    data: data,
    url: `/api/tenant/queryCurrentTenant`,
    method: 'post'
  })
}
// 导入文件
export const uploadRankCost = '/api/hr/user/uploadRankCost'
// 获取租户信息ById
// export const uploadRankCost = (data) => {
//   return axios.request({
//     data: data,
//     url: `/api/hr/user/uploadRankCost`,
//     method: 'post'
//   })
// }
// 安全认证
export const aliAuthenticateSig = '/api/api/aliAuthenticateSig'
